import $ from 'jquery';
import {is_function} from '../../../../Helpers/js/simple.functions';

export class StarRatingGroup {
    constructor(domNode, onChange) {
        this.domNode = domNode;
        this.onChange = onChange;
        this.minValue = parseInt(this.domNode.getAttribute('data-min-value'));
        this.label = this.domNode.querySelector('.star-icons.ui.rating').getAttribute('data-label');
        this.required = this.domNode.querySelector('.star-icons.ui.rating').getAttribute('data-required');
        this.addLabelXStars = this.domNode.querySelector('.star-icons.ui.rating').getAttribute('data-description');
        this.addLabelFirstStar = this.domNode.querySelector('.star-icons.ui.rating').getAttribute('data-description-first');
        this.isReverse = this.domNode.getAttribute('data-reverse') ? true : false;
        this.firstRadioButton = null;
        this.lastRadioButton = null;
        this.selectedStar = null;
        this.hiddenInput = this.domNode.querySelector('input[questiontype="starrating"]');
        $(this.domNode).find('.ui.rating').rating({clearable: true, onRate: this.onRate.bind(this)});
        this.stars = Array.from(this.domNode.querySelectorAll('i.star.icon'));
        this.noAnswer = this.domNode.querySelector('.noanswer');
        this.noAnswerInput = this.domNode.querySelector('.noanswer input');
        this.setInitialAttributes();
        this.setRating(this.hiddenInput.value);
    }

    setInitialAttributes() {
        this.firstRadioButton = this.stars[0];
        this.lastRadioButton = this.stars[this.stars.length - 1];

        this.stars.map((star, index) => {
            var myValue = this.isReverse ? this.minValue - index : this.minValue + index;
            star.setAttribute('data-value', myValue);
            star.setAttribute('role', 'radio');
            star.setAttribute('aria-required', this.required);
            star.setAttribute('aria-label', this.label + ': ' + (index == 0 ? this.addLabelFirstStar : (index + 1 + ' ' + this.addLabelXStars)));
            star.addEventListener('keydown', this.handleKeydown.bind(this));
        });
    }

    resetRating() {
        this.value = '';
        this.hiddenInput.value = '';
        this.selectedStar = null;

        this.updateAttributes();
    }

    setRating(value) {
        this.value = value;
        this.hiddenInput.value = value;
        this.selectedStar = this.domNode.querySelector('[data-value="' + value + '"]');

        this.updateAttributes();

        if (is_function(this.onChange)) {
            this.onChange();
        }
    }

    getDataValue(element) {
        return parseInt(element.getAttribute('data-value'));
    }

    setUncheckedNoAnswer() {
        this.noAnswerInput.checked = false;
        this.noAnswer.setAttribute('aria-checked', 'false');
        this.noAnswer.classList.remove('option-checked');
    }

    updateAttributes() {
        this.stars.map(star => {
            star.tabIndex = -1;
            star.setAttribute('aria-checked', star == this.selectedStar ? 'true' : 'false');
            var starValue = this.getDataValue(star);
            var className = 'star icon';

            if ((this.isReverse && this.value !== '' && starValue >= this.value) ||
                (!this.isReverse && this.value !== '' && starValue <= this.value)) {
                className += ' active';
            }

            star.setAttribute('class', className);
        });

        if (this.selectedStar) {
            this.selectedStar.tabIndex = 0;
        } else {
            this.firstRadioButton.tabIndex = 0;
        }
    }

    setCheckedToPreviousItem(currentRadio) {
        var value;
        if (currentRadio === this.firstRadioButton) {
            value = this.getDataValue(this.lastRadioButton);
        } else {
            var index = this.stars.indexOf(currentRadio);
            value = this.getDataValue(this.stars[index - 1]);
        }

        this.setRating(value);
    }

    setCheckedToNextItem(currentRadio) {
        var value;
        if (currentRadio === this.lastRadioButton) {
            value = this.getDataValue(this.firstRadioButton);
        } else {
            var index = this.stars.indexOf(currentRadio);
            value = this.getDataValue(this.stars[index + 1]);
        }

        this.setRating(value);
    }

    handleKeydown(event) {
        var tgt = event.currentTarget;

        switch (event.key) {
            case ' ': 			//Spacebar
            case 'Spacebar': 	//for older Browsers
            case 'Enter':
                if (this.value == this.getDataValue(tgt)) {
                    this.resetRating();
                } else {
                    this.setRating(this.getDataValue(tgt));
                }
                event.preventDefault();
                break;

            case 'Up':
            case 'ArrowDown':
            case 'Left':
            case 'ArrowLeft':
                this.setCheckedToPreviousItem(tgt);
                event.preventDefault();
                break;

            case 'Down':
            case 'ArrowUp':
            case 'Right':
            case 'ArrowRight':
                this.setCheckedToNextItem(tgt);
                event.preventDefault();
                break;
            default:
                break;
        }

        this.stars.find(star => star.tabIndex == 0).focus();
    }

    onRate(value) {
        if (value === 0) {
            this.resetRating();
        } else {
            var realValue = this.isReverse ? this.minValue - value + 1 : this.minValue + value - 1;
            this.setRating(realValue);
            if (this.noAnswer && this.noAnswerInput.checked == true) {
                this.setUncheckedNoAnswer();
            }
        }
    }
}

